var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17055_185396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 11.9642C15.8761 11.9642 16.9242 10.7664 16.9242 9.28874C16.9242 7.81113 15.8761 6.61328 14.5832 6.61328C13.2903 6.61328 12.2422 7.81113 12.2422 9.28874C12.2422 10.7664 13.2903 11.9642 14.5832 11.9642Z",
    stroke: "#1E1850",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0063 19.1318H10.0176V16.0637C10.0176 14.3334 11.4135 12.9375 13.1438 12.9375",
    stroke: "#1E1850",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7321 12.9375C17.4624 12.9375 18.8583 14.3334 18.8583 16.0637V19.1318H12.6641",
    stroke: "#1E1850",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4998 13.4596C24.4998 18.9414 20.065 23.3763 14.5832 23.3763C9.10138 23.3763 4.6665 18.9414 4.6665 13.4596C4.6665 7.97784 9.10138 3.54297 14.5832 3.54297",
    stroke: "#1E1850",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 10.8307L21.5005 2.16406",
    stroke: "#1E1850",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2087 8.12372C24.2087 8.12372 22.214 10.832 21.5003 10.832C20.7866 10.832 18.792 8.1237 18.792 8.1237",
    stroke: "#1E1850",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17055_185396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownSizeIcon);
export default __webpack_public_path__ + "static/media/downSizeIcon.0ff83c964c4bc2fa3f558f2162342544.svg";
export { ForwardRef as ReactComponent };